// stores/counter.js
import { defineStore } from 'pinia'
import { useHttp } from '@core/composables/useHttp'
import _ from 'lodash-es'
import jwtDefaultConfig from '@/@core/auth/jwt/jwtDefaultConfig'
import { useToast } from 'vue-toastification'
import { camelizeKeys } from 'humps'

const isLoggedIn = !!localStorage.getItem(jwtDefaultConfig.storageTokenKeyName)
const user =
  camelizeKeys(
    JSON.parse(localStorage.getItem(jwtDefaultConfig.storageUserDataKeyName))
  ) || {}

const toast = useToast()

const setUserItemInStorage = (user) => {
  const payload = _.isObject(user) ? user : {}

  localStorage.setItem(
    jwtDefaultConfig.storageUserDataKeyName,
    JSON.stringify(payload)
  )
}

export const useAuthStore = defineStore('auth', {
  state: () => {
    return { isLoggedIn, user }
  },
  actions: {
    setUser(user) {
      console.log('user', user)
      this.isLoggedIn = true
      this.user = user

      setUserItemInStorage(user)
    },

    updateUser(user) {
      this.user = user
      setUserItemInStorage(user)
    },

    getRefreshToken() {
      return new Promise((resolve) => {
        const { execute } = useHttp({
          method: 'POST',
          showErrorToast: false,
          test: 'test',
        })
        execute(
          { url: jwtDefaultConfig.refreshResource },
          ({ token }) => {
            localStorage.setItem(jwtDefaultConfig.storageTokenKeyName, token)
            resolve(token)
          },
          () => {
            localStorage.removeItem(jwtDefaultConfig.storageUserDataKeyName)
            localStorage.removeItem(jwtDefaultConfig.storageTokenKeyName)

            this.isLoggedIn = false
            this.user = {}

            toast.error('You have been logged out due to lack of activity')
            this.router.push('/')
          }
        )
      })
    },

    logout(route) {
      const { execute } = useHttp({ method: 'POST' })
      execute(
        {
          url: jwtDefaultConfig.logoutResource,
        },
        () => {
          this.isLoggedIn = false
          this.user = {}

          localStorage.removeItem(jwtDefaultConfig.storageUserDataKeyName)
          localStorage.removeItem(jwtDefaultConfig.storageTokenKeyName)

          if (route?.name !== 'special-package') {
            this.router.push({ name: 'home' })
          }
        }
      )
    },
  },
  getters: {
    userData: (state) => state?.user,
    userEmail: (state) => state?.user?.email,
    isMaster: ({ userData }) => userData?.master,
  },
})
